import {
    CommunityFacebook,
    requestFacebookOtherParameters,
    requestFacebookParams
} from '@/lib/analytics/pages/community/facebook';
import {
    CommunityInstagram,
    requestInstagramParams
} from '@/lib/analytics/pages/community/instagram';
import { CommunityLinkedin, requestLinkedinParams } from '@/lib/analytics/pages/community/linkedin';
import {
    CommunityPinterest,
    requestPinterestParams
} from '@/lib/analytics/pages/community/pinterest';
import {
    CommunityTiktokBusiness,
    requestTiktokBusinessParams
} from '@/lib/analytics/pages/community/tiktokBusiness';
import { CommunityTwitter, requestTwitterParams } from '@/lib/analytics/pages/community/twitter';
import { CommunityYoutube, requestYoutubeParams } from '@/lib/analytics/pages/community/youtube';
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    TWITTER,
    YOUTUBE
} from '@/lib/socialProfile';

export const CommunityConfig = (type) => {
    let config;
    let fields;
    let parameters;
    const waitForSPTransition = true;
    switch (type) {
        case INSTAGRAM:
            config = CommunityInstagram;
            fields = requestInstagramParams;
            break;
        case TWITTER:
            config = CommunityTwitter;
            fields = requestTwitterParams;
            break;
        case FACEBOOK:
            config = CommunityFacebook;
            fields = requestFacebookParams;
            parameters = requestFacebookOtherParameters;
            break;
        case LINKEDIN:
            config = CommunityLinkedin;
            fields = requestLinkedinParams;
            break;
        case PINTEREST:
            config = CommunityPinterest;
            fields = requestPinterestParams;
            break;
        case TIKTOK_BUSINESS:
            config = CommunityTiktokBusiness;
            fields = requestTiktokBusinessParams;
            break;
        case YOUTUBE:
            config = CommunityYoutube;
            fields = requestYoutubeParams;
            break;
    }
    return { config, fields, parameters, waitForSPTransition };
};
